module.exports = __webpack_public_path__ + "img/4S.3e78de89.svg";